<div [innerHtml]="styles | sanitize: 'HTML'"></div>
